<template>
  <div id="main">
    <app-notification
      v-for="(ntf, index) in appNotifications"
      :key="index"
      :type="ntf.type || 'info'"
      :offset="index * 50"
    >
      {{ ntf.text }}
    </app-notification>
    <app-delete-dialog />
    <side-bar />
    <div id="side_right" :class="{is_active: isSidebarOpen}">
      <top-bar />
      <slot />
    </div>
    <overview />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import Overview from 'components/Overview'
import TopBar from './TopBar'
import SideBar from './SideBar'

export default {
  name: 'private-layout',
  components: {
    TopBar,
    SideBar,
    Overview
  },
  created() {
    this.getEnums()
    this.initParams()
  },
  computed: {
    ...mapState({
      loadingMessage: state => state.layout.loadingMessage,
      appErrors: state => state.layout.errors,
      isSidebarOpen: state => state.layout.isSidebarOpen
    }),
    ...mapGetters([
      'pending'
    ]),
    appNotifications() {
      const arr = []

      if (this.loadingMessage) {
        arr.push({ text: this.loadingMessage })
      } else if (this.pending) { arr.push({ text: this.$gettext('Načítání...') }) }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.appErrors.forEach(v => {
        arr.push(v)
      })

      return arr
    }
  },
  methods: {
    ...mapActions([
      'getEnums',
      'initParams'
    ])
  }
}
</script>
